import React, { useContext } from 'react';
import StravaButton from './StravaButton';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import STRAVA_LOGO from './strava white.svg';

function StravaInfo ()
{
    const { customAttributes } = useContext ( CurrentUserContext );

    let content = null;

    if ( customAttributes && customAttributes["custom:stravaId"] )
    {
        content = <div className="block">
                    <p>Your <img src={STRAVA_LOGO} className="h-4 inline mb-1" alt="Logo for Strava" /> account ({customAttributes["custom:stravaId"]}) is linked.</p>
                    <p className="font-thin font-xs">Any new activity logged within the event will be added to your log and your teams on the leaderboards. Deleted activity will be removed. To ensure any updated Strava activity is sync'd up, please also change the activity's name in Strava.</p>
                </div>
    }
    else
    {
        content = <>
                    <span>Link your Strava account</span>
                    <StravaButton />
                </>
    }

    return <div className="rounded-xl bg-pgdarkteal text-pgwhite p-4 font-bold mt-6 flex flew-row items-center gap-2">
                {content}
            </div>
}

export default StravaInfo;